<template>
    <div class="h-full flex flex-col md:flex-row lg:static bg-surface-50 dark:bg-gray-600">
        <div
            id="app-sidebar-5"
            class="bg-surface-900 hidden md:flex flex-shrink-0 z-10 border-r border-surface-800 w-28 select-none"
        >
            <div class="flex flex-col">
                <div class="mt-4">
                    <ul class="list-none p-4 m-0">
                        <li v-for="(item, index) in navs" :key="index">
                            <a
                                class="flex flex-col items-center cursor-pointer p-4 lg:justify-center hover:bg-blue-800 rounded-border text-surface-300 hover:text-white duration-150 transition-colors"
                                @click="item.action"
                            >
                                <i :class="[item.icon, 'mr-2 lg:mr-0 mb-0 lg:mb-2 !text-xl !leading-none']" />
                                <span class="font-medium inline text-base lg:text-sm lg:block">{{ item.label }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="flex flex-col relative flex-auto overflow-auto">
            <ul class="bg-surface-0 dark:bg-surface-900 p-0 m-0 list-none flex select-none md:hidden">
                <template v-for="(item, index) of navs" :key="index">
                    <li>
                        <a
                            class="cursor-pointer pl-6 pr-6 pt-4 pb-4 flex items-center border-b-2 border-solid transition-colors duration-150"
                            :class="{
                                'border-primary dark:border-primary text-primary hover:border-primary ':
                                    active === index,
                                'text-surface-700 dark:text-surface-0/80 border-transparent hover:border-surface':
                                    active !== index,
                            }"
                            @click="perfomClick(item, index)"
                        >
                            <i :class="[item.icon, '!text-xl', '!leading-none']" class="mr-2" />
                            <span class="font-medium">{{ item.label }}</span>
                        </a>
                    </li>
                </template>
            </ul>

            <Divider layout="horizontal" class="md:hidden m-0 mt-2" />

            <div class="flex flex-col flex-1 h-full p-4 overflow-hidden">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { ref, onMounted, inject } from "vue";
import { Divider } from "primevue";
import { PermissionsEnum } from "@/core/enums/PermissionsEnum";

const authService = inject("authService");
const router = useRouter();
const active = ref();
const navs = ref([
    {
        icon: "pi pi-verified !text-xl !leading-none",
        label: "Review",
        permission: PermissionsEnum.reviewTestimonials,
        action: () => {
            router.push("/settings/review");
        },
    },
    {
        icon: "pi pi-list !text-xl !leading-none",
        label: "Options",
        permission: PermissionsEnum.viewOptions,
        action: () => {
            router.push("/settings/options");
        },
    },
    {
        icon: "pi pi-users !text-xl !leading-none",
        label: "Teams",
        permission: PermissionsEnum.viewUsers,
        action: () => {
            router.push("/settings/teams");
        },
    },
]);

onMounted(async () => {
    navs.value = navs.value.filter((item) => authService.hasPermission(item.permission));

    if (navs.value.length > 0) {
        navs.value[0].action();
    }
});

const perfomClick = (item, index) => {
    active.value = index;
    item.action();
};
</script>
